import React, { useEffect } from 'react';
import { Button } from '@/components/ui/button';

const GTMTestPage = () => {
    useEffect(() => {
        // Remove existing script if present
        const existingScript = document.getElementById('hobbes-widget-script');
        if (existingScript) {
            existingScript.remove();
        }

        // Remove any existing widget root
        const widgetRoot = document.getElementById('syra-widget-root');
        if (widgetRoot) {
            widgetRoot.remove();
        }

        const script = document.createElement('script');
        script.id = 'hobbes-widget-script';
        script.async = true;

        // Use production URL or localhost based on environment
        const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
        script.src = isLocalhost
            ? 'http://localhost:3334/widget.js'
            : 'https://agent.hihobbes.com/widget.js';

        // Configuration
        script.setAttribute('client-key', 'aaca0efd-d49a-4179-887e-89d2d7853096'); // Replace with actual client key
        script.setAttribute('mode', 'sales');
        script.setAttribute('trigger-selector', '#hobbes-trigger');

        document.body.appendChild(script);

        return () => {
            // Cleanup on unmount
            const scriptToRemove = document.getElementById('hobbes-widget-script');
            if (scriptToRemove) {
                scriptToRemove.remove();
            }
            const widgetRootToRemove = document.getElementById('syra-widget-root');
            if (widgetRootToRemove) {
                widgetRootToRemove.remove();
            }
        };
    }, []);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
            <div className="max-w-2xl w-full text-center space-y-8">
                <div className="space-y-4">
                    <div className="flex justify-center">
                        <img
                            src="https://storage.googleapis.com/hobbes-assets/HobbesFavicon.png"
                            alt="Hobbes"
                            className="h-16 rounded-l"
                        />
                    </div>
                    <h1 className="text-4xl font-semibold tracking-tight text-heading sm:text-5xl">
                        Hobbes GTM Agent
                    </h1>
                    <p className="text-lg text-muted-foreground max-w-md mx-auto">
                        Experience the future of Go-To-Market automation with our intelligent agent.
                    </p>
                </div>

                <div className="p-8 rounded-xl border card-border card-bg shadow-sm">
                    <Button
                        id="hobbes-trigger"
                        size="lg"
                        className="w-full text-lg h-12 font-medium"
                        onClick={() => console.log('Say Hi to Hobbes clicked')}
                    >
                        Say Hi to Hobbes
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default GTMTestPage;
